import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { SelectUserModule } from "src/app/app/_component/select-user/select-user.module";
import { HeaderModule } from "src/app/_component/header/header.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { ApiNotFoundComponentModule } from "../../_component/api-not-found/api-not-found.component.module";
import { PaginationClientSideModule } from "../../_component/pagination-client-side/pagination-client-side.module";
import { PriorityModule } from "../../_component/priority/priority.module";
import { SelectButtonsModule } from "../../_component/select-buttons/select-buttons.module";
import { StatusModule } from "../../_component/status/status.module";
import { CardComponentModule } from "../../_component/_structural/card/card.module";
import { ReportTaskModalComponentModule } from "../report-task/report-task-modal/report-task-modal.module";
import { ReportTaskViewModule } from "../report-task-view/report-task-view.module";
import { ReportModule } from "../report/report.module";
import { BreadcrumbComponentModule } from "./../../_component/breadcrumb/breadcrumb.module";
import { EditReportPageRoutingModule } from "./edit-report-routing.module";
import { EditReportPage } from "./edit-report.page";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    EditReportPageRoutingModule,
    TranslateModule,
    ReportModule,
    PaginationClientSideModule,
    ReportTaskViewModule,
    HeaderModule,
    SelectButtonsModule,
    PriorityModule,
    StatusModule,
    SharedDirectivesModule,
    SelectUserModule,
    CardComponentModule,
    BreadcrumbComponentModule,
    ApiNotFoundComponentModule,
    ReportTaskModalComponentModule,
  ],
  declarations: [EditReportPage],
})
export class EditReportPageModule {}
